import type { WidgetTableProps } from '@/components/WidgetTable/types';
import { RelativeTimeWithTooltip } from '@/components/shared/RelativeTimeWithTooltip';

export type ShadowAiUserTool = {
  id: string;
  name: string;
  category: string;
  lastSeenAt: string;
};

export const COLUMNS: WidgetTableProps<ShadowAiUserTool>['columns'] = [
  {
    header: 'Name',
    id: 'name',
    cell: tool => tool.name,
  },
  {
    header: 'Category',
    id: 'category',
    cell: tool => tool.category,
  },
  {
    header: 'Last Seen',
    id: 'lastSeen',
    cell: tool => <RelativeTimeWithTooltip date={tool.lastSeenAt} />,
  },
];
